import { Button, Flex } from '@chakra-ui/react'
import { useRef, useState } from 'react'

import { Close, Search } from '../icons'
import { InputGroup } from './InputGroup'

export const SearchField = ({
  onSearch,
  inputPlaceholder = 'Hledat',
  isDisabled = false,
}: {
  onSearch: (search: string) => void
  inputPlaceholder?: string
  buttonLabel?: string
  isDisabled?: boolean
}) => {
  const [search, setSearch] = useState('')
  const lastValue = useRef('')

  const onSubmit = (value: string) => {
    if (value !== lastValue.current) {
      lastValue.current = value
      onSearch(value)
    }
  }

  return (
    <Flex sx={{ gap: 2 }}>
      <InputGroup
        bgColor="none"
        borderBottom="none"
        border="1px solid"
        borderColor="neutral.100"
        borderRadius="sm"
        w={{ base: '100%', sm: '64' }}
        placeholder={inputPlaceholder}
        _placeholder={{
          color: 'chakra-placeholder-color',
          fontWeight: 'normal',
        }}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter')
            onSubmit(search)
        }}
        rightElement={
          <Flex gap={2}>
            {search && (
              <Button
                variant={'unstyled'}
                onClick={() => {
                  setSearch('')
                  onSubmit('')
                }}
              >
                <Close />
              </Button>
            )}

            <Button
              mr={-1}
              isDisabled={isDisabled}
              variant={'unstyled'}
              _active={{ boxShadow: 'none' }}
              onClick={() => onSubmit(search)}
            >
              <Search color="secondary.500" />
            </Button>
          </Flex>
        }
      />
    </Flex>
  )
}
